import { render, staticRenderFns } from "./ADay.vue?vue&type=template&id=2dc43c8a&scoped=true"
import script from "./ADay.vue?vue&type=script&lang=js"
export * from "./ADay.vue?vue&type=script&lang=js"
import style0 from "./ADay.vue?vue&type=style&index=0&id=2dc43c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc43c8a",
  null
  
)

export default component.exports